import { Suspense, lazy } from "react";
import "./App.css";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import { Toaster } from "sonner";

const HomePage  = lazy(() => import("./components/HomePage"));
const BlogList  = lazy(() => import("./components/BlogList"));
const BlogPost  = lazy(() => import("./components/BlogPost"));
const AdminAuth = lazy(() => import("./components/admin/AdminAuth"));

const PageLoader = () => (
  <div className="min-h-screen bg-white flex items-center justify-center">
    <div className="w-6 h-6 border-2 border-gray-300 border-t-gray-900 rounded-full animate-spin" />
  </div>
);

function App() {
  return (
    <div className="App">
      <Toaster position="bottom-right" richColors />
      <BrowserRouter>
        <Suspense fallback={<PageLoader />}>
          <Routes>
            <Route path="/"        element={<HomePage />} />
            <Route path="/blog"    element={<BlogList />} />
            <Route path="/blog/:slug" element={<BlogPost />} />
            <Route path="/admin/*" element={<AdminAuth />} />
          </Routes>
        </Suspense>
      </BrowserRouter>
    </div>
  );
}

export default App;